import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "¿Qué es exactamente SIRCS?",
    a: "SIRCS (Sistema Integrado de Reprogramación Cognitiva y Subconsciente) es una comunidad privada en Skool donde aprendes a identificar y reescribir los patrones mentales que dirigen tu vida en automático. No es un curso pasivo: es un sistema activo de transformación con protocolos, mentoría y acompañamiento.",
  },
  {
    q: "¿Cuánto cuesta y qué incluye?",
    a: "$47/mes o $299/año con prueba gratuita inicial. Incluye acceso completo a la comunidad, protocolos paso a paso, mentoría con Santi Lorenzo y la biblioteca de patrones y disparadores. Cancelas cuando quieras, sin permanencia.",
  },
  {
    q: "¿Esto es terapia psicológica?",
    a: "No. SIRCS no sustituye terapia. Es un sistema de entrenamiento mental basado en psicología práctica, neurociencia aplicada y disciplina diaria. Si necesitas atención clínica, trabájalo con un profesional. SIRCS complementa, no reemplaza.",
  },
  {
    q: "¿Cuánto tiempo voy a tardar en notar cambios?",
    a: "Los primeros días ya empiezas a ver tus patrones con claridad — esa visibilidad por sí sola cambia decisiones. La reprogramación profunda es trabajo sostenido: piensa en semanas y meses, no en días, pero verás progreso desde la primera semana.",
  },
  {
    q: "¿Y si entro y veo que no es para mí?",
    a: "Cancelas en un clic. Por eso existe la prueba gratuita: entra, observa, decide. Si no es tu sistema, te vas sin perder nada.",
  },
  {
    q: "¿Cómo funciona la comunidad en Skool?",
    a: "Todo el contenido, las conversaciones, los protocolos y la mentoría viven dentro de la plataforma Skool. Al hacer clic en 'Comenzar prueba gratis' creas tu cuenta en Skool y entras directamente a la comunidad privada.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="surface-dark relative py-24 sm:py-32">
      <div className="warm-halo" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-pearl/40" />
            <span className="font-body text-[11px] tracking-[0.28em] uppercase text-pearl/70">
              06 · FAQ
            </span>
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-normal tracking-[-0.02em] leading-[1.0] text-cream"
          >
            Preguntas
            <br />
            <em className="italic text-pearl">de quien ya las pensó.</em>
          </motion.h2>
        </div>

        <div className="lg:col-span-8" data-testid="faq-list">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#1E252F]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display text-xl sm:text-2xl font-normal tracking-[-0.01em] hover:no-underline hover:text-warm py-6 text-cream">
                  <span className="flex items-start gap-5">
                    <span className="font-body text-[11px] tracking-[0.24em] text-warm/80 pt-2 shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="font-body text-pearl/80 text-base leading-relaxed pl-14 pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
